import React from 'react';
import PropTypes from 'prop-types';

import useV3OfferPool from '../hooks/useV3OfferPool';

// O-2783 "pool over offers". Segmented [Independent | Pool] control at the top
// of the lineup rail. Flipping to Pool find-or-creates the group's pool (or
// PATCHes its mode); flipping to Independent PATCHes the pool back to inert.
//
// Gated behind the `multi_artist_v3_offers` package entitlement only — always
// visible when that is on (even a single-artist lineup; the booker may be about
// to add more artists).
const MODES = [
  { value: 'independent', label: 'Independent' },
  { value: 'pool', label: 'Pool' },
];

const V3OfferPoolToggle = ({ team, offer }) => {
  const { setMode, isSavingPool } = useV3OfferPool();

  if (!team?.package?.multi_artist_v3_offers) return null;

  // Before a pool exists, reflect the team's configured default (pilot teams
  // default to Pool) instead of a hardcoded 'independent'. Once the group is
  // multi-artist the server auto-creates the pool in this mode (see
  // V3Offer#apply_team_default_pool_mode!), so the toggle and the real mode agree.
  const defaultMode = team?.package?.default_v3_offer_display_mode || 'independent';
  const mode = offer?.v3_offer_pool?.mode || defaultMode;

  const handleClick = (next) => {
    if (next === mode || isSavingPool) return;
    setMode(next);
  };

  return (
    <div className="lineup-rail__pool-toggle" data-testid="v3-offer-pool-toggle">
      <span
        className="deal-terms-segmented"
        role="radiogroup"
        aria-label="Lineup payout mode"
      >
        {MODES.map((opt) => (
          <button
            type="button"
            key={opt.value}
            className={`deal-terms-segmented__btn ${mode === opt.value ? 'deal-terms-segmented__btn--active' : ''}`}
            onClick={() => handleClick(opt.value)}
            aria-pressed={mode === opt.value}
            disabled={isSavingPool}
          >
            {opt.label}
          </button>
        ))}
      </span>
    </div>
  );
};

V3OfferPoolToggle.propTypes = {
  team: PropTypes.object,
  offer: PropTypes.object,
};

V3OfferPoolToggle.defaultProps = {
  team: null,
  offer: null,
};

export default V3OfferPoolToggle;
